module.exports = __webpack_public_path__ + "static/danmak-11b7784a34b629be2f3a26b19f9379fd.png";